import { Id, SpaceTrackRow } from "@highnote/server/src/core/entities";
import { getSpaceTrackRowId } from "@highnote/server/src/core/shared-util";
import { useGlobalSpaceTracks } from "./useGlobalSpaceTracks";

/**
 * One `space-tracks-v1` row from the store, by (space, track).
 *
 * The store is filled by the space's child-entity watcher
 * (`useChildEntityWatchers`, attached by `useSpaceContext` for the route's
 * space and by every expanded space row for its own). So on a `/space/S/T`
 * route the row for (S, T) is present once the space has loaded; for a
 * space that is not being watched, this returns undefined and the caller
 * must fall back to the canonical track.
 */
export const useSpaceTrackRow = (
  spaceId?: Id,
  trackId?: Id,
): SpaceTrackRow | undefined => {
  const { globalSpaceTracks } = useGlobalSpaceTracks();
  if (!spaceId || !trackId) return undefined;
  return globalSpaceTracks.spaceTrackRows.get(
    getSpaceTrackRowId(spaceId, trackId),
  );
};
